<template>
    <div
        v-if="expanded"
        :class="expand.sidebar"
        class="overflow-auto w-100 config-index">
        <div class="sidebar-content d-flex flex-column w-100 flex-grow-1" :class="headerFixed ? 'header-fixed' : 'header-not-fixed'">
            <slot name="header">
                <!-- Header Slot  -->
            </slot>
            <div class="list-group-item d-flex justify-content-between align-items-center">
                <i v-if="info" type="button" class="btn-tooltip mdi mdi-24px mdi-information-outline" data-toggle="tooltip" data-placement="top" :title="info" data-animation="true"></i>
                <h4 class="mb-0">{{$t(title)}}</h4>
                <BaseButton
                    outline
                    class="btn-icon-only rounded-circle"
                    @click="expanded = !expanded"
                    type="secondary">
                    <i class="mdi mdi-window-close"></i>
                </BaseButton>
            </div>
            <slot>
                <!-- Default Slot -->
            </slot>
        </div>
    </div>
    <button v-else-if="showToggle" class="nch--content-toggle" :class="right ? 'right' : ''" @click="expanded = true">
        <i v-if="icon" :class="icon"></i>
        <i 
            v-else
            class="mdi" 
            :class="right 
                ? 'mdi-arrow-left-circle-outline' 
                : 'mdi-arrow-right-circle-outline'"
        ></i>
    </button>
</template>

<script>
import BaseButton from '../../argon/components/BaseButton'

export default {
    emits: ['input', 'update:modelValue'],

    name: 'ContentSideBar',

    components: {
        BaseButton,
    },

    props: {
        title: String,
        icon: String,
        showToggle: Boolean,
        right: Boolean,
        headerFixed: Boolean,
        info: String,
        modelValue: {
            type: [Boolean, Number]
        },
    },

    computed: {
        expanded: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            }
        },

        expand() {
            return {
                content: this.expanded ? 'nch--content-container' : 'nch--content-container-expand',
                sidebar: this.expanded ? 'nch--sidebar-container' : 'nch--sidebar-container-expand'
            }
        },
    },

}
</script>

<style scoped>
.sidebar-content {
    height: 100%
}

.list-group-item {
    border: none;
}

.config-index {
    z-index: 70;
}
</style>
